import { useTranslation } from 'react-i18next';

export const keyPrefix = 'user_department_list';
export const useUserDepartmentListTranslation = () => useTranslation('widgets', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Подразделения',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Departments',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Departamentos',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Departamentos',
  },
}) : {}) as Record<string, unknown>;
